import {SOUNDS as PREFIX} from '../const/';
import {IVR_SOUND_FETCH_LIST_API} from "../const/apiMethods";
import {api} from '../api/loginRoutes';
import {createAction} from  './defaults';

const setLoading = createAction('SET_LOADING_' + PREFIX);
const setSoundsList = createAction('SET_ITEMS_' + PREFIX);


export const getSoundList = (filter) => (dispatch) => {
    dispatch(setLoading(true));
    api(IVR_SOUND_FETCH_LIST_API, {filter})
        .then((r) => {
            if (!r || !r?.ivr_sound_list) {
                return;
            }

            dispatch(setSoundsList({list: r.ivr_sound_list}));
        })
        .finally(() => dispatch(setLoading(false)));
};